const initESW = function (gslbBaseURL) {
    embedded_svc.settings.displayHelpButton = true;
    embedded_svc.settings.language = '';
    embedded_svc.settings.defaultMinimizedText = ' ';
    if (window.location.href.indexOf('/livechat-on-mobile-app') > -1) {
        embedded_svc.settings.extraPrechatFormDetails = [
            {
                label: 'Site URL',
                value: window.location.href,
                displayToAgent: true,
                transcriptFields: ['ChatPageURL__c'],
            },
            {
                label: 'Device Type',
                value: 'App',
                displayToAgent: true,
                transcriptFields: ['DeviceType__c'],
            },
        ];
    } else {
        embedded_svc.settings.extraPrechatFormDetails = [
            {
                label: 'Site URL',
                value: window.location.href,
                displayToAgent: true,
                transcriptFields: ['ChatPageURL__c'],
            },
            {
                label: 'Device Type',
                value: 'Web',
                displayToAgent: true,
                transcriptFields: ['DeviceType__c'],
            },
        ];
    }
    embedded_svc.settings.disabledMinimizedText = ' ';
    embedded_svc.settings.loadingText = ' ';

    embedded_svc.settings.enabledFeatures = ['LiveAgent'];
    embedded_svc.settings.entryFeature = 'LiveAgent';
    embedded_svc.init(
        'https://iapro.my.salesforce.com',
        'https://gusglobal.force.com/agentportals',
        gslbBaseURL,
        '00D0O000000qr9a',
        'LSBF_UK',
        {
            baseLiveAgentContentURL:
                'https://c.la3-c2-cdg.salesforceliveagent.com/content',
            deploymentId: '5720X0000000HNq',
            buttonId: '57367000000XfXC',
            baseLiveAgentURL:
                'https://d.la3-c2-cdg.salesforceliveagent.com/chat',
            eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I67000000fy2nEAA_186baa4bae5',
            isOfflineSupportEnabled: false,
        }
    );
};
if (!window.embedded_svc) {
    const s = document.createElement('script');
    s.setAttribute(
        'src',
        'https://iapro.my.salesforce.com/embeddedservice/5.0/esw.min.js'
    );
    s.onload = function () {
        initESW(null);
    };
    document.body.appendChild(s);
} else {
    initESW('https://service.force.com');
}
